import { STORAGE_KEY } from "../constants/storageKeys";
import { decryptData, encryptData } from "./storageHelper";
export function removeLocalStorage(item) {
    localStorage.removeItem(item);
}
export function setLocalStorage(item, value) {
    const encryptedData = encryptData(JSON.stringify(value));
    localStorage.setItem(item, encryptedData);
}
export function getLocalStorage(item) {
    try {
        const encryptedData = localStorage.getItem(item);
        if (encryptedData) {
            const decryptedData = decryptData(encryptedData);
            return JSON.parse(decryptedData)
        }
        return null;
    } catch (error) {
        //console.log(error);
        return null
    }

}

export function clearLoginGameInfo() {
    removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
    removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
    removeLocalStorage(STORAGE_KEY.SERVER_INFO);
    removeLocalStorage(STORAGE_KEY.USER_INFO);
    removeLocalStorage(STORAGE_KEY.TOKEN);
}